// React
import { memo, useCallback, useState } from "react";

// Helpers
import { classNames, useTranslate } from "helpers";

// Types
import { TableRowChildProps } from "ui/components/Table/TableSearch/types";

// Routing


// Third-party libs
import { ReactSVG } from "react-svg";

// UI Components
import { Dialog } from "ui/components/Dialog";
import { deleteFleetVehicleExpenseUploadAPI } from "services/api/fleet/vehicles/expenses/api";
import { PictureIcon } from "ui/components/Pictures";

const VehicleExpenseRowChild: React.FC<TableRowChildProps> = (props) => {
  const { index, row, onFetchSearchResult } = props;

  const { t } = useTranslate();
  const [uploadId, setUploadId] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);

  // const handleRowClick = useCallback(
  //   (rowId: string) => (event: React.MouseEvent<unknown>) => {
  //     event.stopPropagation();
  //     event.preventDefault();

  //     navigate(
  //       transformRoute(FleetTireRoutes.FleetTireDetailPageRouter, {
  //         id: rowId,
  //       })
  //     );
  //   },
  //   [navigate]
  // );

  const handleDownloadClick = async (e: React.MouseEvent<HTMLButtonElement>, name: string, url: string) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      setIsLoading(true);

      // 1. Fetch file kao blob
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error("Download failed");
      }

      const blob = await response.blob();

      // 2. Napravi blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      // 3. Napravi <a> i klikni ga
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = name;
      document.body.appendChild(link);
      link.click();

      // 4. Cleanup
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("Download error:", err);
    } finally {
      setIsLoading(false);
    }
  }

  const handleDeleteClick = (event: React.MouseEvent<HTMLSpanElement, MouseEvent>, id: string) => {
    event.stopPropagation();
    event.preventDefault();

    setUploadId(id);
    setOpenDialog(true);
  }

  const handleDriverDeleteDialogConfirm = useCallback(async () => {
    if (!uploadId) return;

    try {
      const deleted = await deleteFleetVehicleExpenseUploadAPI(
        row.vehicleExpenseId,
        uploadId,
        t
      );

      if (deleted && onFetchSearchResult) {
        await onFetchSearchResult();

      }

      // zatvori dijalog nakon brisanja
      setOpenDialog(false);
      setUploadId("");
    } catch (err) {
      console.error("Greška prilikom brisanja dokumenta:", err);
    }
  }, [uploadId, t]);

  const handleDriverDeleteDialogClose = useCallback(() => {
    setUploadId("");
    setOpenDialog(false);
  }, []);


  return (
    <>
      <tr className={classNames(
        "hover:bg-slate-100",
        index % 2 === 0 ? "bg-white" : " bg-slate-50"
      )}>
        <td className={classNames("px-4 py-2 text-sm font-medium flex-1")}>
           <PictureIcon url={row.url} />
        </td>
        <td className={classNames("px-4 py-4 text-sm font-medium flex-1")}>
           <button type="button" className="group inline-flex items-center text-sm font-medium rounded-md underline text-slate-500 bg-slate-100 hover:bg-slate-200 ml-4 px-3 py-1 text-sm text-blue-500 cursor-pointer" onClick={(e) => handleDownloadClick(e, row.originalFileName, row.url)}>
          {row.originalFileName}
          </button>
        </td>
 
        <td>
          <span onClick={(e) => handleDeleteClick(e, row.id)} className="block w-10 h-10 flex items-center justify-center cursor-pointer bg-red-50  hover:bg-red-100 rounded-full" >
            <ReactSVG
              src={"/media/icons/trash.svg"}
              className="w-4 h-4 stroke-[#bd0000]"
            />
          </span>
        </td>
      </tr>
      <Dialog
        open={openDialog}
        title={t(
          "admin.fleet.vehicle.expense.dialog.delete.title"
        )}
        message={t(
          "admin.fleet.vehicle.expense.dialog.delete.message"
        )}
        confirmText={t(
          "admin.fleet.vehicle.expense.dialog.delete.confirmtext"
        )}
        cancelText={t(
          "admin.fleet.vehicle.expense.dialog.delete.canceltext"
        )}
        onConfirm={handleDriverDeleteDialogConfirm}
        onCancel={handleDriverDeleteDialogClose}
      />
    </>
  );
};

export default memo(VehicleExpenseRowChild);
